const NW_IC_CLICK_ID = 'NW_IC_CLICK_ID';
const NW_IC_SHORT_CLICK_ID = 'NW_IC_SHORT_CLICK_ID';
const isEmptyOrSpaces = (str) => {
  return str === null || str.match(/^ *$/) !== null;
};

export const isFormattedForPartnerTrackingInjection = (url) => {
  const result =
    url.match(NW_IC_CLICK_ID, 'g') || url.match(NW_IC_SHORT_CLICK_ID, 'g');
  return result && result.length === 1;
};

export const generateShortTrackingId = (trackingId, length) => {
  let res = '';
  const a = trackingId.substring(0, length);
  const b = trackingId.substring(length);
  let i = a.length;
  let j = b.length;
  while (i > 0) {
    res =
      // eslint-disable-next-line no-bitwise
      (parseInt(a.charAt(i), 16) ^ parseInt(b.charAt(j), 16)).toString(16) +
      res;
    i -= 1;
    j = j > 0 ? j - 1 : b.length;
  }
  return res;
};

export const injectPartnerTrackingId = (url, trackingId) => {
  let res = url.replace(NW_IC_CLICK_ID, trackingId);
  res = new URL(res);
  res.searchParams.forEach((value) => {
    if (value.includes(NW_IC_SHORT_CLICK_ID)) {
      const values = value.split('_');
      const len = parseInt(values[values.length - 1], 10) || 10;
      res = res
        .toString()
        .replace(value, generateShortTrackingId(trackingId, len).toUpperCase());
    }
  });
  return res.toString();
};

export const updateQueryParams = (url, params) => {
  const separator = url.indexOf('?') > -1 ? '&' : '?';
  const u = new URL(url);
  u.search = u.search + separator + params;
  return u.href;
};

export const queryParamExists = (url, param) => {
  const urlObj = new URL(url);
  const params = urlObj.searchParams;
  return params.has(param) && !isEmptyOrSpaces(params.get(param));
};
